import PropChainTracker from "../../../prop-tracker-utils/prop-chain-tracker.js";
import DictTrackerObjGen from "../../../prop-tracker-utils/dict-tracker-obj-gen.js";

import LabelTrackerLinker from "./label-tracker-linker.js";

class LabelLinking {
    constructor(canvasLabelLinker) {
        this._labelTrackLinker = new LabelTrackerLinker(canvasLabelLinker);
    }

    track(labels) {
        if (labels) {
            this._labelTrackLinker.trackLabels(labels.data, labels.events);
        } else {
            this._labelTrackLinker.trackLabels();
        }
    }

    update() {
        this._labelTrackLinker.update();
    }
}

export default LabelLinking;
